import PropTypes from 'prop-types';

import Footer from '../../../../../../components/Footer';
import NarrativeFlowView from '../../../../components/NarrativeFlowView';
import NarrativeTitle from '../../../../components/NarrativeFlowView/components/NarrativeTitle';
import NarrativeTopicCard from '../../../../components/NarrativeFlowView/components/NarrativeTopicCard';
import { mapFlowStateComponentsToDrafts } from '@api/chat/utilities/helpers';

import {
  buildDraftFlowData,
  buildDraftTopicData,
  buildTopicShell,
  EMPTY_DOWNLOAD_MAP,
} from '../../utilities/helpers';

import styles from './_index.module.scss';

const NarrativesCanvas = ({ flowId, flowState }) => {
  if (flowId) {
    return (
      <div className={styles['narratives-canvas-container']}>
        <div className={styles['narratives-canvas-content']}>
          <NarrativeFlowView flowId={flowId} hidePageTitle={true} useWindowScroll={false} />
        </div>
        <Footer />
      </div>
    );
  }

  const draftTopics = flowState ? mapFlowStateComponentsToDrafts(flowState) : [];
  const draftFlowData = buildDraftFlowData(flowState);

  if (!draftTopics.length) {
    return (
      <div className={styles['narratives-canvas-container']}>
        <div className={styles['narratives-canvas-content']} />
        <Footer />
      </div>
    );
  }

  return (
    <div className={styles['narratives-canvas-container']}>
      <div className={styles['narratives-canvas-content']}>
        <div className={styles['narratives-canvas-draft-view']}>
          {draftFlowData && (
            <NarrativeTitle
              downloadData={EMPTY_DOWNLOAD_MAP}
              flowData={draftFlowData}
              handleReprompt={() => {}}
              setFlow={() => {}}
              showToolbar={false}
            />
          )}
          <div className={styles['narratives-canvas-draft-grid']}>
            {draftTopics.map((draft, index) => (
              <NarrativeTopicCard
                initialTopicData={buildDraftTopicData(draft)}
                isDraftCard={true}
                key={draft.id}
                keyIndex={index}
                onPreview={() => {}}
                setDownloadData={() => {}}
                topic={buildTopicShell(draft)}
                useWindowScroll={false}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

NarrativesCanvas.propTypes = {
  flowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  flowState: PropTypes.object,
};

export default NarrativesCanvas;
